module.exports = __webpack_public_path__ + "img/legend-match.284524eb.png";